<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"

import { getStyle } from "@/utils/status"

const { t } = useI18n()

const { value, field, model } = defineProps({
  value: { type: String, required: true },
  field: { type: String, required: true },
  model: { type: String, required: true },
})

const styleClass = computed(() => {
  return `text-bg-${getStyle(`${model}.${field}.${value}`)}`
})
const text = computed(() => {
  return t(`${model}.${field}List.${value}`)
})
</script>

<template>
  <span class="badge" :class="styleClass">{{ text }}</span>
</template>

<style scoped></style>
